<template>
    <div v-if="blok" v-editable="blok">
        <details
            class="accordion-item group border-grey-750/10 my-2 overflow-hidden rounded-lg border bg-white transition-colors"
        >
            <summary
                class="hover:bg-grey-50 cursor-pointer list-none rounded-lg p-4 select-none group-open:rounded-b-none"
            >
                <BaseHeading
                    v-if="blok.title"
                    :level="6"
                    class="!mb-0 !flex items-center justify-between gap-4"
                >
                    {{ blok.title }}
                    <BaseIcon
                        postnord-icon
                        name="angle-small-down"
                        class="flex-none group-open:hidden"
                    />
                    <BaseIcon
                        postnord-icon
                        name="angle-small-up"
                        class="hidden flex-none group-open:block"
                    />
                </BaseHeading>
            </summary>
            <div class="px-4 pb-5">
                <RichText :rich-text="blok.text" paragraph-class="last:!mb-0" />
            </div>
        </details>
    </div>
</template>

<script setup lang="ts">
import type { AccordionItemStoryblok } from '~/app/types/storyblok-types';
import BaseHeading from '../ui/BaseHeading.vue';
import BaseIcon from '../ui/BaseIcon.vue';
import RichText from '../ui/RichText.vue';

defineProps<{ blok: AccordionItemStoryblok }>();
</script>

<style scoped>
@reference "../../assets/css/main.css";
.accordion-item {
    summary::-webkit-details-marker {
        @apply hidden;
    }
}
</style>
